/*
 * filename: table.js
 * Get the user data from store and show
 * */

import React, { Component } from 'react';
import { connect } from 'react-redux';
import { NavLink } from 'react-router-dom';
import {
  Table,
  TableBody,
  TableHeader,
  TableHeaderColumn,
  TableRow,
  TableRowColumn,
} from 'material-ui/Table';
import RaisedButton from 'material-ui/RaisedButton';
import { Field, reduxForm, reset } from 'redux-form';

import { renderTextField } from '../components/reduxFields';
// import SortingCustom from '../components/SortingCustom'
import { showFormatedDate, base64Encode, resetFiltersAndSorting } from '../actions/utilAction';
import PaginatorCustom from '../components/paginationCustom';
import { getStaffDocuments } from '../modules/Dashboards/actions/StaffDashboardActions';

/**
 * A simple table demonstrating the hierarchy of the `Table` component and its sub-components.
 */
class StaffDocuemntsTable extends Component {

  constructor(props) {
    super(props);
    this.filter = {
      sort_Column: '',
      sort_order: '',
      searchText: '',
    };
    this.handleSearchStaffDocs = this.handleSearchStaffDocs.bind(this);
    this.handleSearchChange = this.handleSearchChange.bind(this);
    this.setSortColumn = this.setSortColumn.bind(this);
  }

  loadStaffDocuments(page_number) {
    let searchObj2 = {
      userId: 0,
      pageNumber: page_number ? page_number : 1,
      pageSize: 10,
      sort_fields: this.filter.sort_Column || '',
      sort_order: this.filter.sort_order || '',
      contain_filters: { SearchText: this.filter.searchText || '' },
    };
    this.props.SendQueryparams(searchObj2)
    this.props.getStaffDocuments(searchObj2);
  }

  handleSearchStaffDocs() {
    return false;
  }

  handleReset = () => {
    this.props.dispatch(reset('StaffDocuemntsTableForm'));
    resetFiltersAndSorting(this.filter, 'id', true);
    this.filter.sort_Column = '';
    this.filter.sort_order = '';
    this.loadStaffDocuments();
  };

  handleSearchChange(event) {
    if (event.target.value.length > 0) {
      this.filter.searchText = event.target.value;
      this.loadStaffDocuments();
    } else if (event.target.value.length === 0) {
      this.filter.searchText = '';
      this.loadStaffDocuments();
    }
  }

  setSortColumn(col_name, col_order) {
    if (col_name) {
      this.filter.sort_Column = col_name;
      this.filter.sort_order = col_order;
      this.loadStaffDocuments();
    }
  }


  showTableData() {
    return this.props.StaffDocmuents.data.map((data) => {
      let staffId = base64Encode(`${data.staffId}`);
      return (
        <TableRow key={data.authorizationId} style={{ background: `${data.warningColorCode}` }}>
          <TableRowColumn style={{ width: '35%' }}><NavLink to={`/user-documents/${staffId}`} exact >{data.staffName}</NavLink></TableRowColumn>
          <TableRowColumn style={{ width: '40%' }}>{data.otherDocumentType ? 'Other (' + data.otherDocumentType + ')' : data.documentTypeNameStaff}</TableRowColumn>
          <TableRowColumn style={{ width: '25%' }}>{showFormatedDate(data.expiration)}</TableRowColumn>
        </TableRow>
      );
    });
  }

  render() {
    const { handleSubmit } = this.props;
    return (
      <div>
        <div className="row">
          <div className="col-sm-12">
            <div className="row end-flex">
              <div className="col-sm-9 mtm-27">
                <form className="readmin-form custom_form" onSubmit={handleSubmit(this.handleSearchStaffDocs)}>
                  <Field
                    name="staffDocs"
                    floatingLabelText="Search"
                    maxLength='25'
                    onChange={this.handleSearchChange}
                    component={renderTextField}
                  />
                </form>
              </div>
              <div className="reset-btn col-sm-3 btn_rt">
                <RaisedButton className="grey_btn ml_15" onTouchTap={this.handleReset}>Reset</RaisedButton>
              </div>
            </div>
          </div>
        </div>
        <Table>
          <TableHeader displaySelectAll={false} adjustForCheckbox={false}>
            <TableRow >
              <TableHeaderColumn style={{ width: '35%' }}>Staff Name</TableHeaderColumn>
              <TableHeaderColumn style={{ width: '40%' }}>Document Type</TableHeaderColumn>
              <TableHeaderColumn style={{ width: '25%' }}>Expiration Date</TableHeaderColumn>
            </TableRow>
          </TableHeader>
          <TableBody displayRowCheckbox={false}>
            {this.props.StaffDocmuents && this.props.StaffDocmuents.data && this.props.StaffDocmuents.data.length > 0 ?
              this.showTableData()
              :
              <TableRow>
                <TableRowColumn colSpan="3">No Record Found</TableRowColumn>
              </TableRow>
            }
          </TableBody>
        </Table>
        {this.props.StaffDocmuents.data && this.props.StaffDocmuents.data.length ?
          <PaginatorCustom data={this.props.StaffDocmuents.meta} handlePageChange={(page_number) => this.loadStaffDocuments(page_number)} />
          : null}
      </div>
    );
  }
}

StaffDocuemntsTable = reduxForm({
  form: 'StaffDocuemntsTableForm',
})(StaffDocuemntsTable);


function mapStateToProps(state) {
  //  console.log('state.staff_dashboard.StaffDocmuents..............', state.staff_dashboard ? state.staff_dashboard.StaffDocmuents : {},);
  return {
    StaffDocmuents: state.staff_dashboard ? state.staff_dashboard.StaffDocuments : {},
    LeftPanel_loading: state.staff_dashboard.LeftPanel_loading,
  };
}

export default connect(mapStateToProps, { getStaffDocuments })(StaffDocuemntsTable);



// WEBPACK FOOTER //
// ./src/adminCharts/StaffDocuemntsTable.js